import { CircularProgress } from "@mui/material";
import clsx from "clsx";
import type React from "react";
import { LoadingBox, classes } from "./styles";

export interface ILoadingProps {
  loading: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const Loading = ({ loading, className, children }: ILoadingProps) => {
  if (!loading) {
    return children ? <>{children}</> : null;
  }
  return (
    <LoadingBox className={clsx(classes.root, className)}>
      <CircularProgress />
    </LoadingBox>
  );
};
